import type * as HeadlineThree from '../types/HeadlineThree'

export default function headlineThreeComponentParser(
  rawComponent: HeadlineThree.Raw,
): HeadlineThree.Parsed {
  const props = rawComponent.headlineThree

  return {
    name: 'HeadlineThree',
    props,
  }
}
